var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08579 25.9192C7.89689 24.0082 9.79063 22.668 11.9974 22.668H19.9974C22.2042 22.668 24.0979 24.0082 24.909 25.9192M21.3307 12.668C21.3307 15.6135 18.9429 18.0013 15.9974 18.0013C13.0519 18.0013 10.6641 15.6135 10.6641 12.668C10.6641 9.72245 13.0519 7.33464 15.9974 7.33464C18.9429 7.33464 21.3307 9.72245 21.3307 12.668ZM29.3307 16.0013C29.3307 23.3651 23.3612 29.3346 15.9974 29.3346C8.6336 29.3346 2.66406 23.3651 2.66406 16.0013C2.66406 8.63751 8.6336 2.66797 15.9974 2.66797C23.3612 2.66797 29.3307 8.63751 29.3307 16.0013Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.738337289d477b17824055327f0568a9.svg";
export { ForwardRef as ReactComponent };